import Request from '@/services/request';
import { ENDPOINT_SHIPMENT_MODAL_CONTROL } from '@/utils/enum/endpoints';
import { checkWmsAgreementStatus } from '@/services/wmsAgreementService';
import {
  SHIPMENT_TEMPLATE_CONTROL,
  DOCUMENT_CONTROL,
  SELLER_SHOP_CONTROL,
} from '@/utils/enum/pageCheckControl';
import {
  ADD_NEW_PRODUCT,
  BULK_PRODUCT_UPLOAD,
  ADD_CATALOG_PRODUCT,
  ADD_PRODUCT,
  ADD_SINGLE_PRODUCT,
  SUPPLIES_MANAGEMENT,
} from '@/utils/enum/menuId';
import {
  SET_MENU_CLICKED_CONTROL_MODAL_DATA,
  SET_WMS_AGREEMENT_MODAL_DATA,
} from './mutation-types';

const request = new Request();

const handleSuppliesManagementNavigation = async ({ commit }, href) => {
  try {
    const { approved, contractContent } = await checkWmsAgreementStatus();

    if (approved) {
      if (href) window.location.href = href;
      return true;
    }

    commit(SET_WMS_AGREEMENT_MODAL_DATA, {
      open: true,
      contractContent,
      redirectHref: href || '/supplies-management',
    });
    return false;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const onNavigationChange = async ({ commit }, { id, href }) => {
  if (id === SUPPLIES_MANAGEMENT) {
    return handleSuppliesManagementNavigation({ commit }, href);
  }

  if (
    ![
      ADD_NEW_PRODUCT,
      BULK_PRODUCT_UPLOAD,
      ADD_PRODUCT,
      ADD_CATALOG_PRODUCT,
      ADD_SINGLE_PRODUCT,
    ].includes(id)
  )
    return;

  try {
    const { data } = await request.get(ENDPOINT_SHIPMENT_MODAL_CONTROL);
    const { hobimDocumentApproved, validSeller, sppApproved } = data || {};

    if (!hobimDocumentApproved) {
      commit(SET_MENU_CLICKED_CONTROL_MODAL_DATA, DOCUMENT_CONTROL);
      return;
    }

    if (!validSeller) {
      commit(SET_MENU_CLICKED_CONTROL_MODAL_DATA, SELLER_SHOP_CONTROL);
      return;
    }

    if (sppApproved) {
      if (href) window.location.href = href;
      return true;
    }

    commit(SET_MENU_CLICKED_CONTROL_MODAL_DATA, SHIPMENT_TEMPLATE_CONTROL);
  } catch (error) {
    console.error(error);
    commit(SET_MENU_CLICKED_CONTROL_MODAL_DATA, {});
  }
};

const catalogPageCheckControl = async ({ commit }) => {
  try {
    const { data } = await request.get(ENDPOINT_SHIPMENT_MODAL_CONTROL);
    const { hobimDocumentApproved, validSeller } = data || {};

    if (hobimDocumentApproved && validSeller) {
      return true;
    }

    if (
      (!hobimDocumentApproved && !validSeller) ||
      (!hobimDocumentApproved && validSeller)
    ) {
      commit(SET_MENU_CLICKED_CONTROL_MODAL_DATA, DOCUMENT_CONTROL);
      return false;
    }

    if (hobimDocumentApproved && !validSeller) {
      commit(SET_MENU_CLICKED_CONTROL_MODAL_DATA, SELLER_SHOP_CONTROL);
      return false;
    }
  } catch {
    return false;
  }
};

const bulkUpdatePageDocumentControl = async ({ commit }) => {
  try {
    const { data } = await request.get(ENDPOINT_SHIPMENT_MODAL_CONTROL);
    const { hobimDocumentApproved, validSeller, sppApproved } = data || {};

    if (hobimDocumentApproved && validSeller) {
      if (sppApproved) {
        return true;
      }

      commit(SET_MENU_CLICKED_CONTROL_MODAL_DATA, SHIPMENT_TEMPLATE_CONTROL);
      return;
    }

    const controlModalData = !hobimDocumentApproved
      ? DOCUMENT_CONTROL
      : SELLER_SHOP_CONTROL;

    commit(SET_MENU_CLICKED_CONTROL_MODAL_DATA, controlModalData);
  } catch (error) {
    console.error(error);
    return false;
  }
};

export default {
  onNavigationChange,
  handleSuppliesManagementNavigation,
  catalogPageCheckControl,
  bulkUpdatePageDocumentControl,
};
